"use client";

import { Box, Card } from "@mui/material";
import useEmblaCarousel from "embla-carousel-react";
import { ReactNode, useEffect } from "react";
import CarouselFooter from "./CarouselFooter";
import Autoplay from "embla-carousel-autoplay";
export default function BannerCarousel({ banners }: { banners: ReactNode[] }) {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, direction: "rtl", dragFree: false, align: "start" }, [
    // @ts-ignore
    Autoplay({ playOnInit: true, delay: 4000 }),
  ]);
  useEffect(() => {
    if (emblaApi) {
      // Embla API is ready
    }
  }, [emblaApi]);

  const slideSpacingXs = "1rem";
  const slideSizeXs = "calc(100%)";
  return (
    <>
      {/* embla */}
      <Box width={"100%"} sx={{ position: "relative" }}>
        {/*  embla__viewport */}
        <Box sx={{ overflow: "hidden", position: "relative" }} ref={emblaRef}>
          {/* embla__container */}
          <Box
            sx={{
              backfaceVisibility: "hidden",
              display: "flex",
              touchAction: "pan-y pinch-zoom",
              py: 0.2,
              mr: {
                xs: `calc(${slideSpacingXs} * -1)`,
              },
            }}
          >
            {banners.map((slide, index) => {
              return (
                // embla__slide
                <Box
                  key={index}
                  sx={{
                    minWidth: 0,
                    flex: {
                      xs: `0 0 ${slideSizeXs}`,
                    },
                    pr: {
                      xs: `${slideSpacingXs}`,
                    },
                  }}
                >
                  {slide}
                </Box>
              );
            })}
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5, py: 1 }}>
            <CarouselFooter emblaApi={emblaApi as any} />
          </Box>
        </Box>
      </Box>
    </>
  );
}
